// extracted by mini-css-extract-plugin
export default {"header":"dhbrm__header--e7763","title":"dhbrm__title--a27ec","saken":"dhbrm__saken--c82ce","updating":"dhbrm__updating--f5ffa","dot":"dhbrm__dot--f4b15"};